import React from 'react'

interface CustomTableDataCTAProps extends React.PropsWithChildren {
  dataLabel?: string
  className?: string
  text: string
}

const CustomTableDataCTA = ({ dataLabel, text, children }: CustomTableDataCTAProps) => {
  return (
    <td
      // data-label={dataLabel}
      className="p-2.5 group relative font-normal"
    >
      <p className="hidden sm:block h-full">{text}</p>
      <p className="h-full font-semibold sm:hidden">{'More...'}</p>

      <div className="absolute z-10 bottom-8 right-0 invisible group-hover:visible shadow cursor-pointer w-40 rounded-xl overflow-hidden shadow-[4px_4px_20px_4px_rgba(33,37,41,0.10)] border bg-white text-left">
        {children}
      </div>
    </td>
  )
}

export default CustomTableDataCTA

/*

*/
